/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-02-28 15:57:14
 * @Description: 维保计划管理服务
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const gzwxService = {

  query: (params) => { return axios.get(`${iffApi}/xfwb/gzwx/query`, { params: params }); },

  // 删除
  delete: (id) => { return axios.delete(`${iffApi}/xfwb/gzwx/detail/${id}`); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/xfwb/gzwx/save`, fd); },

  // 获取详情
  getInfo: (id) => { return axios.get(`${iffApi}/xfwb/gzwx/detail/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/xfwb/gzwx/export`, { responseType: 'blob', params }); },

  // 设备文件上传
  importGzwxFile: (id, file) => { return axios.post(`${iffApi}/xfwb/gzwx/${id}/import`); },

  // 设备模板下载
  exportGzwxFile: () => { return axios.get(`${iffApi}/xfwb/gzwx/export/mb`, { responseType: 'blob' }); }
};
